import LxnxFilterSchema from '../schemas/LxnxFilterSchema'

export default function LxnxFilterVo(obj = {}) {
  return LxnxFilterSchema.validateSync(obj)
}
